import { useContext, useRef } from 'react'
import { ProductContext } from 'src/components/restructure/product/contexts'
import { formatterPrice } from 'src/utils/formatterPrice'

export function InstallmentV2() {
  const { currentSku } = useContext(ProductContext)
  const {
    sellerDefault: {
      sellerOffer: {
        installments,
        bestInstallment: bestInstallmentDefault,
        cashDiscountPercentage,
        price,
      },
    },
  } = currentSku

  const containerRef = useRef<HTMLDivElement | null>(null)

  const notDecathlonCardInstallments = installments.filter(
    ({ onlyDecathlonCard }) => !onlyDecathlonCard
  )

  const bestInstallment = bestInstallmentDefault?.onlyDecathlonCard
    ? notDecathlonCardInstallments.pop()
    : bestInstallmentDefault

  const isInterestFree = !bestInstallment?.InterestRate

  return (
    <>
      {installments.length > 0 && bestInstallment && (
        <div
          ref={containerRef}
          className="relative w-full max-w-[245px] text-sm text-postal-primary font-medium"
        >
          <span>
            ou{' '}
            {!!cashDiscountPercentage && (
              <>
                <strong>{formatterPrice(price)}</strong> em até{' '}
              </>
            )}
            {bestInstallment.NumberOfInstallments}x{' '}
            <>
              de <strong>{formatterPrice(bestInstallment.Value)}</strong>
            </>{' '}
            {isInterestFree && 'sem juros'}
          </span>
        </div>
      )}
    </>
  )
}
